import { BaseEtlImport, EtlImportListSchema } from "etl/types";
import { createAppAsyncThunk } from "../../../../store/store.types";

export type LoadImportsResponse = {
	etlImports: BaseEtlImport[];
};

export const loadEtlImports = createAppAsyncThunk<LoadImportsResponse, void>(
	"import/load",
	async (_, { extra, rejectWithValue, getState }) => {
		try {
			const { user } = getState().auth;

			const allEtlImports = await extra.etlClient.findAll(EtlImportListSchema);

			const etlImports = allEtlImports.filter((etlImport) => etlImport.company_id === user?.company.id);

			return { etlImports };
		} catch (error) {
			return rejectWithValue(error);
		}
	},
	{
		condition: (_, { getState }) => {
			const { isLoadingImports } = getState().etlData;
			const { user } = getState().auth;
			if (!user) return false;
			if (isLoadingImports) return false;
		}
	}
);
